import React from "react";

const categories = [
  {
    title: "Frontend",
    skills: [
      { name: "Angular", icon: "A", bg: "#dd0031", color: "#fff", level: 92 },
      { name: "React", icon: "R", bg: "#61dafb", color: "#000", level: 85 },
      { name: "TypeScript", icon: "T", bg: "#3178c6", color: "#fff", level: 88 },
      { name: "JavaScript", icon: "J", bg: "#f0db4f", color: "#000", level: 90 },
      { name: "Bootstrap", icon: "B", bg: "#563d7c", color: "#fff", level: 80 },
    ],
  },
  {
    title: "Backend & Database",
    skills: [
      { name: "PostgreSQL", icon: "P", bg: "#336791", color: "#fff", level: 87 },
      { name: "Node.js", icon: "N", bg: "#3c873a", color: "#fff", level: 82 },
      { name: "Express", icon: "E", bg: "#333", color: "#fff", level: 78 },
      { name: "MongoDB", icon: "M", bg: "#47a248", color: "#fff", level: 75 },
      { name: "MySQL", icon: "S", bg: "#00758f", color: "#fff", level: 70 },
    ],
  },
  {
    title: "Tools & Other",
    skills: [
      { name: "Git", icon: "G", bg: "#f05032", color: "#fff", level: 88 },
      { name: "VS Code", icon: "V", bg: "#007acc", color: "#fff", level: 95 },
      { name: "RxJS", icon: "R", bg: "#9c5af2", color: "#fff", level: 80 },
      { name: "Three.js", icon: "T", bg: "#ff6b35", color: "#fff", level: 60 },
      { name: "HTML/CSS", icon: "H", bg: "#1a1a2e", color: "#a0a0b8", level: 92 },
    ],
  },
];

const Skills = () => {
  return (
    <section id="skills" style={{ padding: "6rem 5%" }}>
      <div className="section-inner">
        <p className="section-label">Tech stack</p>
        <h2 className="section-title">Skills &amp; tools</h2>
        <p className="section-sub">
          From frontend frameworks to database engineering — things I use daily and am
          confident shipping with.
        </p>
        <div className="skills-grid">
          {categories.map((cat) => (
            <div key={cat.title} className="skill-cat">
              <div className="skill-cat-title">{cat.title}</div>
              <div className="skill-items">
                {cat.skills.map((s) => (
                  <div key={s.name} className="skill-item">
                    <div className="skill-name">
                      <div
                        className="skill-icon"
                        style={{ background: s.bg, color: s.color }}
                      >
                        {s.icon}
                      </div>
                      {s.name}
                    </div>
                    <div className="skill-bar-wrap">
                      <div className="skill-bar" style={{ width: `${s.level}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
